// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Alert styling */
.clientdashboard-alert-info {
  background-color: #f0f8ff; /* Light blue background */
  color: #2e275a; /* Dark blue text */
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

/* Client profile page container */
.clientdashboard-profile-page {
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/ClientProfile.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,mBAAmB;EACnC,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;AACd","sourcesContent":["/* Alert styling */\n.clientdashboard-alert-info {\n  background-color: #f0f8ff; /* Light blue background */\n  color: #2e275a; /* Dark blue text */\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n/* Client profile page container */\n.clientdashboard-profile-page {\n  padding: 2rem;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
